// @NOTE: assumes jQuery is included by WP
const $ = jQuery

class fancyLoad {
	constructor () {
		this.$elementsToFancyLoad = $('.home-project-block-content > .inner')
		this.$window              = $(window)

		this.onWindowResize()
		this.onWindowScroll(window.scrollY)
		this.addSpecificClassToLastElement();
	}

	onWindowResize (windowWidth) {
		this.windowHeight         = this.$window.outerHeight()
		this.thresholdPixels      = this.windowHeight * .3
		this.createDivsAndOffsetsArray()
	}

	onWindowScroll (scrollTop) {
		if(this.divsAndOffsetsArray.length < 1) {
			return
		}

		const animationPoint = scrollTop + this.windowHeight - this.thresholdPixels
		var indexesToRemove = []

		for (var i = 0; i < this.divsAndOffsetsArray.length; i++) {
			const elementAndOffset = this.divsAndOffsetsArray[i]

			if(elementAndOffset.offset <= animationPoint) {
				elementAndOffset.element.addClass('post-animation')
				indexesToRemove.push(i)
			}
		}

		// Calculate windowHeight and thresholdPixels for the last element with 'last-block-item'
		let lastElement = this.divsAndOffsetsArray[this.divsAndOffsetsArray.length - 1].element;
		//console.log(this.isElementInViewport(lastElement, scrollTop));
		 if (this.isElementInViewport(lastElement, scrollTop)) {
			lastElement.addClass('post-animation');
		}

		for (var j = (indexesToRemove.length - 1); j >= 0; j--) {
			this.divsAndOffsetsArray.splice(indexesToRemove[j], 1)
		}
	}

	createDivsAndOffsetsArray () {
		this.divsAndOffsetsArray  = []

		this.$elementsToFancyLoad.each((index, element) => {
			const $element = $(element)
			const elementOffset = $element.offset().top

			this.divsAndOffsetsArray.push({
				offset: elementOffset,
				element: $element
			})
		})
	}

	addSpecificClassToLastElement() {
    if (this.divsAndOffsetsArray.length > 0) {
      const lastElement = this.divsAndOffsetsArray[this.divsAndOffsetsArray.length - 1].element;
      lastElement.addClass('last-block-item');
    }
  }

  isElementInViewport(element, scrollTop) {
		const elementTop = element.offset().top + 20;
		const elementHeight = element.outerHeight();
		const windowHeight = this.$window.height();
		//console.log(elementHeight);
		//console.log(scrollTop);
		//console.log(elementTop);
		return elementTop < (scrollTop + windowHeight) && (elementTop + elementHeight) > scrollTop;
	}
}

export default fancyLoad


// WEBPACK FOOTER //
// ./src/js/shg/fancyLoad/fancyLoad.js